export {default} from "./svg-path.mjs";
